import {defineAsyncComponent} from 'vue'
const RelativesLeaderRouter = [
  {
    path: 'manager_leader',
    name: 'RelativesLeader',
    redirect: 'OrganizeLeaderSet',
    meta: {
      key: 'relatives-leader'
    },
    children: [
      {
        path: 'leader_set',
        name: 'OrganizeLeaderSet',
        component: () => import('@/views/Relatives/LeaderSet.vue'),
        meta: {
          key: 'relatives-leader'
        }
      },
      {
        path: 'bound',
        name: 'OrganizeConfigure',
        component: () => import('@/views/Relatives/Configure.vue'),
        meta: {
          key: 'relatives-leader'
        }
      },
      {
        path: 'summary',
        name: 'OrganizeLeader',
        component: () => import('@/views/Relatives/Leader.vue'),
        meta: {
          key: 'relatives-leader'
        }
      },
      {
        path: 'director',
        name: 'OrganizeLeaderManager',
        component: () => import('@/views/Relatives/LeaderManager.vue'),
        meta: {
          key: 'relatives-leader'
        }
      },
    ]
  },
  
]
export {RelativesLeaderRouter}
